const duration = 2;
const delayMultiplier = 0.08;

export const getImpulseFromRightDuration = (linesCount: number) => {
  return duration + Math.floor(linesCount / 2) * delayMultiplier;
};

export const impulseFromRightConfig = {
  duration,
  delayMultiplier,
};
